import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  countries: [],
  totalRows: 0,
  loading: false,
  errorMsg: '',
  errors: {},
};

const helperSlice = createSlice({
  name: 'helpers',
  initialState,
  reducers: {
    countries: (state, action) => {
      state.countries = action.payload;
    },
    setTotalRows: (state, action) => {
      state.totalRows = action.payload;
    },
    getErrors: (state, action) => {
      state.errorMsg = action.payload.errorMsg;
      state.errors = action.payload.errors;
    },
    clearErrors: (state) => {
      state.errorMsg = '';
      state.errors = '';
    },
    loading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { loading, countries, setTotalRows, clearErrors, getErrors } =
  helperSlice.actions;
export default helperSlice.reducer;
